var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('row',[_c('col12',[_c('v-card',{attrs:{"elevation":"2"}},[_c('v-card-text',[_c('gravatar-chooser',{on:{"update":_vm.update_avatar}}),_c('row',[_c('col12',[_c('v-btn',{staticClass:"mr-4",attrs:{"color":"primary"},on:{"click":_vm.save_avatar}},[_vm._v(" "+_vm._s(_vm.$t('myprofile.save'))+" ")])],1)],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }